import { useQuery } from '@tanstack/react-query'

interface QueryParams<TData> {
  queryKey: string
  queryFn: () => Promise<TData[]>
}

interface QueryResults<TData> {
  data?: TData[]
  isLoading: boolean
  isError: boolean
}

export const useQueryDataFetcher = <TData,>({
  queryKey,
  queryFn
}: QueryParams<TData>): QueryResults<TData> => {
  const { isLoading, isError, data } = useQuery<TData[]>({
    queryKey: [queryKey],
    queryFn: queryFn,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    retry: 3
  })

  return { isLoading, isError, data }
}
